import { Loader2 } from 'lucide-react';

export default function AppLoadingScreen({ message }: { message?: string }) {
  return (
    <div className="flex-1 flex flex-col items-center justify-center gap-3 bg-gray-50">
      <Loader2 className="w-8 h-8 text-emerald-600 animate-spin" />
      {message && <p className="text-gray-500 text-sm">{message}</p>}
    </div>
  );
}
